/**
 * Extract user-friendly error message from API/unknown errors
 * @param {Error|unknown} err
 * @param {string} fallback - Default message when extraction fails
 * @returns {string}
 */
export function getErrorMessage(err, fallback = 'An unexpected error occurred') {
  if (err == null) return fallback;
  if (typeof err === 'string') return err || fallback;
  if (err.userMessage) return err.userMessage;
  if (err.message) return err.message;
  if (err.response?.data) {
    const d = err.response.data;
    if (typeof d === 'string') return d || fallback;
    if (d.error) {
      const e = d.error;
      if (typeof e === 'string') return e;
      if (e?.__all__) {
        const msgs = Array.isArray(e.__all__) ? e.__all__ : [String(e.__all__)];
        return msgs.join(' ') || fallback;
      }
    }
    if (d.detail) return typeof d.detail === 'string' ? d.detail : JSON.stringify(d.detail);
    if (d.message) return d.message;
  }
  return fallback;
}
